import React from 'react';
import { View } from '../types';
import { CyzorHome } from '../components/home/CyzorHome';
import { SettingsView } from '../components/settings/SettingsView';
import { WorkspaceModulesView } from '../modules/dashboard/WorkspaceModulesView';

/**
 * View Router - Maps views to components
 * Consolidates platform views in a single place
 */

export function ViewRouter({ view }: { view: View | 'admin' }) {
  switch (view as string) {
    case 'dashboard':
      return <CyzorHome />;

    case 'configuracoes':
    case 'settings':
    case 'workspace-settings':
    case 'workspace-members':
    case 'workspace-roles':
      return <SettingsView />;

    case 'workspace-modules':
      return <WorkspaceModulesView />;

    default:
      // Fallback for app-specific views (handled by AppRouter)
      return null;
  }
}

/**
 * Check if view is a platform view (not an app-specific view)
 */
export function isPlatformView(view: string): boolean {
  const platformViews = ['dashboard', 'configuracoes', 'settings', 'workspace-settings', 'workspace-members', 'workspace-roles', 'workspace-modules'];
  return platformViews.includes(view);
}
